module.exports = __webpack_public_path__ + "img/TV-show.94ca31f3.png";